// extracted by mini-css-extract-plugin
export default {"portfolio":"portfolio_portfolio__YHmg6","title":"portfolio_title__6B0M4","prev":"portfolio_prev__jJgmi","next":"portfolio_next__l3pth"};